import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';
import { DownloadPaymentScheduleCSV } from '../../models/download-payment-schedule-csv.model';
import { Milestone2PaymentBatchDetails } from '../../models/milestone2-payment-batch-details.model';
import { MsaipPaymentBatchList } from '../../models/msaip-payment-batch-list.model';
import { MsaipPaymentScheduleActivitiesM2 } from '../../models/msaip-payment-schedule-activities-m2.model';
import { PaymentBatchMilestone2 } from '../../models/payment-batch-milestone2.model';
import { PaymentBatchStatusM2 } from '../../models/payment-batch-status-m2.model';
import { SettingsService } from '../common/settings.service';

@Injectable({
  providedIn: 'root'
})
export class MsaipPaymentScheduleService {
  constructor(
    private http: HttpClient,
    public settings: SettingsService
  ) {}

  getMsaipMilestone2PaymentBatch(): Observable<MsaipPaymentBatchList[]> {
    return this.http.get<MsaipPaymentBatchList[]>(
      this.settings.baseUrl +
        'api/MsaipPaymentSchedule/GetAllMSAIPMilestone2PaymentBatch'
    );
  }

  createMsaipPaymentBatchMilestone2(createpb: PaymentBatchMilestone2) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl +
        'api/MsaipPaymentSchedule/SubmitMSAIPPaymentBatchMilestone2',
      createpb,
      { headers }
    );
  }

  GetMsaipMilestone2PaymentScheduleActivities(): Observable<
    MsaipPaymentScheduleActivitiesM2[]
  > {
    return this.http.get<MsaipPaymentScheduleActivitiesM2[]>(
      this.settings.baseUrl +
        'api/MsaipPaymentSchedule/GetMSAIPMilestone2PaymentScheduleActivities'
    );
  }

  getMilestone2PaymentBatchStatus(): Observable<PaymentBatchStatusM2[]> {
    return this.http.get<PaymentBatchStatusM2[]>(
      this.settings.baseUrl +
        'api/PaymentSchedule/GetMilestone2PaymentBatchStatus'
    );
  }

  getMsaipMilestone2PaymentBatchActivities(
    pbName: string
  ): Observable<Milestone2PaymentBatchDetails> {
    return this.http.get<Milestone2PaymentBatchDetails>(
      this.settings.baseUrl +
        'api/MsaipPaymentSchedule/GetMsapiMilestone2PaymentBatchActivities/' +
        pbName
    );
  }

  updateMSAIPMilestone2PaymentBatch(editpb: Milestone2PaymentBatchDetails) {
    return this.http.post<ApiResponse>(
      this.settings.baseUrl +
        'api/MsaipPaymentSchedule/EditMSAIPMilestone2PaymentSchedule',
      editpb
    );
  }

  getDownloadCSVFileEdit(
    fileName: string
  ): Observable<DownloadPaymentScheduleCSV[]> {
    return this.http.get<DownloadPaymentScheduleCSV[]>(
      this.settings.baseUrl +
        'api/PaymentSchedule/ListofPaymentScheduleCsvFiles/EDIT/' +
        fileName
    );
  }

  downloadExportPoeCSV(selectedID: any[]) {
    const headers = new HttpHeaders();
    return this.http.post(
      this.settings.baseUrl + 'api/PoeInformation/DownloadPOESurveyDocs',
      selectedID,
      { headers, responseType: 'blob' }
    );
  }
}
